"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
exports.sandwichIds = {
    summary: {
        status: {
            ok: 'meter-reads-summary-okStatus-image',
            warning: {
                smart: 'meter-reads-summary-smartWarningStatus-image',
                traditional: 'meter-reads-summary-traditionalWarningStatus-image',
            },
            due: 'meter-reads-summary-dueStatus-image',
        },
    },
    noDataError: 'meter-reads-noDataError-image',
};
